import React from "react";
import { useImmer } from "use-immer";

import { ChipProps } from "@mui/material";

import { IgChip } from "./IgChip";

interface IgFlipChipProps extends ChipProps {
  onClick: () => void;

  hoverText?: string;
  isRowHovered?: boolean;
}

export const IgFlipChip = (props: IgFlipChipProps) => {
  const [isHovered, setIsHovered] = useImmer<boolean>(false);
  const { onClick, isRowHovered, hoverText, label, color, ...rest } = props;
  const isChipHovered = isHovered || isRowHovered;

  return (
    <IgChip
      label={isChipHovered ? hoverText || "Unarchive" : label || "Archived"}
      {...rest}
      color={isChipHovered ? "info" : color}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    />
  );
};
